import { render, staticRenderFns } from "./household-editor.vue?vue&type=template&id=1b2d2052&scoped=true"
import script from "./household-editor.vue?vue&type=script&lang=js"
export * from "./household-editor.vue?vue&type=script&lang=js"
import style0 from "./household-editor.vue?vue&type=style&index=0&id=1b2d2052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2d2052",
  null
  
)

export default component.exports